<template>
  <v-card>
    <v-card-title style="background-color: #2b3990">
      <span class="headline white--text">{{ titleForm  }}</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="6" sm="6" md="6">
            <v-autocomplete
              v-model="newCertificationType"
              label="Certification Type"
              :items="status"
              @change="getCertifications()"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" sm="6" md="6">
            <v-autocomplete
              v-model="newCertification"
              label="Certification"
              :items="certs"
              item-text="Name"
              item-value="Name"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6">
            <v-textarea
              v-model="newFocus"
              label="Focus"
              outlined
            ></v-textarea>
          </v-col>
          <v-col cols="12" sm="6">
            <v-textarea
              v-model="newDetails"
              label="Details"
              outlined
            ></v-textarea>
          </v-col>
          <v-col cols="12" sm="6">

            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="true"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="newDateIssued"
                  label="Date Issued"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="newDateIssued"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu1 = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6">

            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="newExpiration"
                  label="Certification Expires"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  clear-icon='$clear'
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="newExpiration"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu2 = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  :disabled="!isExpirationDateValid()"
                  @click="menu2 = false"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="newNotes"
              label="Notes"
              outlined
            ></v-textarea>
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              label="Certification Status"
              :items="certStatus"
              v-model="newStatus"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6">
            <form enctype="multipart/form-data">
              <v-file-input
                v-model="newDocument"
                class="pa-2"
                label="Certification"
                filled
                multiple
                prepend-icon="mdi-camera"
                accept="image/*, .pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                @change="fileSelected"
                show-size
              >
                <template #selection="{ text, index }">
                  <v-chip small label close color="primary" @click:close="deleteChip(index)">{{ text }}</v-chip>
                </template>
              </v-file-input>
            </form>
          </v-col>
            <v-carousel v-if="imageDetails.length > 0">
              <template v-for="(item, index) in imageDetails">
                <v-carousel-item
                  :key="index"
                >
                  <v-row class="flex-nowrap" style="height:100%">
                    <v-img :src="item.AWSLink">
                      <v-row class="fill-height"
                            align="center"
                            justify="center"
                      >
                        <div style="color: #000;padding-top: 30%;">{{ item.Name }}</div>
                      </v-row>

                    </v-img>

                  </v-row>
                </v-carousel-item>
              </template>
            </v-carousel>
            <template v-if="pdfDetails.length > 0">
              <v-col cols="12" sm="12" md="12">
                <div v-for="(item, i) in pdfDetails"
                  :key="i"
                >
                  <LoadPDF
                    :pdfFile="item.aws"
                    :pdfName="item.name"
                  />
                </div>
              </v-col>
            </template>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="#259647" class="white--text" @click="addStaffCert()" v-if="newStaffCert && !isAuditorRole">Save</v-btn
      >
      <v-btn color="#259647" class="white--text" @click="updateStaffCert()" v-if="editStaffCert && !isAuditorRole">Update</v-btn
      >
      <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import axios from 'axios'
import LoadPDF from '@/components/LoadPDF.vue'
import fileRenamer from '../../mixins/fileRenamer';
import Swal from "sweetalert2";

const url = require("../../client_config/config").url;

export default {
  mixins: [fileRenamer],
  components: {
    LoadPDF,
  },
  data: function () {
    return {
      employeeID: this.$route.params.employeeID,
      status: ["State Required", "Mandatory", "Elective"],
      staffCertID: this.$route.params.id,
      newCertificationType: "",
      newCertification: "",
      newFocus: "",
      newDetails: "",
      newDateIssued: null,
      newExpiration: null,
      newNotes: "",
      newStatus: "Current",
      certStatus: [
        "Current",
        "Archived"
      ],
      newDocument: [],
      imageDetails: [],
      pdfDetails:[],
      newDocumentImage: "",
      documents: "",
      newEmployeeID: "",
      certs: [],
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      expired: [],
      staffCerts: [],
      isLoading: false,
      uploadFile: "",
      userState: localStorage.getItem('userState'),
    }
  },

  created(){
    this.getCertifications();
    this.getStaffCerts();

    if (this.staffCertID) {
      this.viewCertification();
    }
  },

  methods: {
    isExpirationDateValid() {
        if (!this.newDateIssued || !this.newExpiration) return false;
        return this.newExpiration > this.newDateIssued;
    },
    getCertifications: function() {
      const certificationType = this.newCertificationType; // Selected certification type
      const userState = this.userState; // Selected user state
      axios.get(`${url}/certifications/${certificationType}/${userState}`, { params: { Company: this.companyId } })
        .then(res => {
            this.certs = res.data.Active; // Update the certs list with the active certifications
        })
        .catch(err => console.error(err));
    },

    getStaffCerts: function() {
      this.isLoading = true;
      axios.get(`${url}/staffCertifications/staff/${this.employeeID}`)
        .then(response => {
          this.tempData = response.data.staffCerts;
          this.expired = [];
          this.staffCerts = [];
          for(var i = 0; i < this.tempData.length; i++){
            if(this.tempData[i].Status == 'Archived'){
              this.expired.push(this.tempData[i])
            } else {
              this.staffCerts.push(this.tempData[i])
            }
          }
        })
        .catch(error => console.log({error}))
        .finally(() => this.isLoading = false);
    },

    addStaffCert: async function() {
      const activeCertification = this.staffCerts.find(cert => cert.Status === 'Current' && cert.Certification === this.newCertification);
      if (activeCertification) {
        // If an active certification is found, show a confirmation dialog
        const confirmation = confirm(`You already have an active certification (${activeCertification.Certification}). Do you want to archive it and submit the new certification?`);
        if (confirmation) {
          this.archiveCertification(activeCertification._id);
        }
      }

      const req_body = {
        CertificationType: this.newCertificationType,
        Certification: this.newCertification,
        Focus: this.newFocus,
        Details: this.newDetails,
        DateIssued: this.newDateIssued,
        Expiration: this.newExpiration,
        Notes: this.newNotes,
        Status: 'Current',
        EmployeeID: this.employeeID,
      };


      try {
        const res = await axios.post(`${url}/staffCertifications`, req_body);

        if (res.status === 400) {
          const data = await res.json();
          Swal.fire({
            icon: 'error',
            title: 'Validation Error',
            text: data.msg || 'Could not add certification due to invalid data.'
          });
          return;
        }

        this.staffCertID = res.data._id;

        if (this.uploadFile !== null && this.uploadFile !== undefined && this.uploadFile.length > 0) {

          Swal.fire({
            title: 'Saving File',
            text: 'Please wait while we\'re saving your file...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });

          try {
            await this.saveFile();
            Swal.close();
            await Swal.fire({
              icon: 'success',
              title: 'Success!',
              text: 'The new certification and file(s) have been added successfully.',
              timer: 2000,
              showConfirmButton: false
            });
          } catch (saveError) {
            Swal.close();
            await Swal.fire({
              icon: 'error',
              title: 'File Upload Error',
              text: 'The certification record was added, but an error occurred uploading the file(s). Please check or try again.'
            });
            return;
          }
        } else {
          await Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'The new certification has been added successfully.'
          });
        }
        this.close();
      } catch (error) {
        console.error('General error adding certification:', error);
        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Operation Failed',
          text: 'An unexpected error occurred. Please try again.'
        });
      }
    },

    archiveCertification(certificationId) {
      const req_body = {
        Status: 'Archived',
      };

      axios.put(`${url}/staffCertifications/${certificationId}`, req_body).then(() => {
        this.msg = true;
        this.text = 'Certification has been archived.';
      }).catch(error => {
        console.error('Error archiving certification:', error);
      });
    },

    async fileSelected(e) {
      const data = {
        userName: this.staffName,
        formName: this.newCertification,
        date: this.newDateIssued
      }
      this.uploadFile= await this.fileRenamer(e, data);
    },

    async saveFile() {
      this.message = "";
      for (let i = 0; i < this.uploadFile.length; i++) {
        await this.uploadFiles(this.uploadFile[i]);
      }
    },

    async uploadFiles(file) {
      const formData = new FormData();
      formData.append('certification', file);
      const ct = { headers:{"content-type" : "multipart/form-data"}};
      try {
        const res = await axios.post(`${url}/staffCertifications/upload/fileuploader/${this.staffCertID}/${this.employeeID}`,
          formData,
          ct);
        if(res){
          console.log('uploaded file:', file.name);
        }
        return res;
      } catch (err) {
        console.error('Error uploading file:', file.name, err);
        throw err;
      }
    },

    deleteChip(index) {
      // Prompt here with text if required
      this.newDocument.splice(index, 1);
    },

    clearDateExpires() {
      if (this.newExpiration !== ""){
        this.newExpiration = ""
      }
    },

    close() {
      this.$router.go(-1);
    },

    viewCertification() {
      axios.get(`${url}/staffCertifications/${this.staffCertID}` ).then(res => {
        console.log(res.data);
        const item = res.data.staffCert;
        this.newCertificationType= item.CertificationType;
        this.newCertification= item.Certification;
        this.newFocus= item.Focus;
        this.newDetails= item.Details;
        this.newDateIssued= item.DateIssued;
        this.newExpiration= item.Expiration;
        this.newNotes= item.Notes;
        this.newStatus = item.Status;

        if(item.documents.length > 0){
          const tempData = [];
          for(let i = 0; i < item.documents.length ; i++){
            tempData.push({
              name: item.documents[i].Name,
            });

            let fileExt = item.documents[i].AWSLink.split('.').pop();
            if (fileExt == "pdf") {
              this.pdfDetails.push(
                {
                  name: item.documents[i].Name,
                  id:   item.documents[i]._id,
                  aws:  item.documents[i].AWSLink
                }
              );
            } else {
              this.imageDetails.push(item.documents[i]);
            }
          }
          this.newDocument = tempData;
        }
      });
    },
    saveExpirationDate() {
        if (this.isExpirationDateValid()) {
            this.$refs.menu2[0].save(this.newExpiration);
        }

        this.menu2 = false;
    },


    updateStaffCert() {
      if(this.newExpiration == null){
        var req_body = {
          CertificationType: this.newCertificationType,
          Certification: this.newCertification,
          Focus: this.newFocus,
          Details: this.newDetails,
          DateIssued: this.newDateIssued,
          Expiration: "",
          Notes: this.newNotes,
          Status: this.newStatus
        }
      } else {
        req_body = {
          CertificationType: this.newCertificationType,
          Certification: this.newCertification,
          Focus: this.newFocus,
          Details: this.newDetails,
          DateIssued: this.newDateIssued,
          Expiration: this.newExpiration,
          Notes: this.newNotes,
          Status: this.newStatus
        };
      }

      axios.put(`${url}/staffCertifications/${this.staffCertID}`, req_body).then((response) => {
        this.getStaffCerts();
        if (response.status == 400) {
          response.json().then(function(data) {
            alert(data.msg);
          });
        }
        if (this.uploadFile !== null && this.uploadFile !== undefined) {
            this.saveFile();
        }
        this.msg =true;
        this.text ="The certification has been updated successfully.";

      });

      setTimeout(this.close(), 3000);
    },
  },

  computed: {
    staffName() {
      return this.$store.state.staff.staff.Name;
    },

    newStaffCert(){
      return this.$route.params.action == 'add' ? true : false;
    },

    editStaffCert() {
      return this.$route.params.action == 'edit' ? true : false;
    },

    titleForm() {
      return this.$route.params.action == 'add' ? 'Add Certification' : 'Edit Certification';
    },

    isAuditorRole() {
        return localStorage.getItem("userRole") === 'Auditor'
    }
  }

}

</script>
